import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function AbonosTiendasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ABONOS_TIENDAS = process.env.REACT_APP_URL_ABONOS_TIENDAS;
  const URL_VENTAS_TIENDAS = process.env.REACT_APP_URL_VENTAS_TIENDAS;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_NOTAS_CARGO = process.env.REACT_APP_URL_NOTAS_CARGO;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_CEDIS;
  const AREAS_MELI = process.env.REACT_APP_AREAS_MELI_1_FULL;
  const AREAS_MELI_NOVA = process.env.REACT_APP_AREAS_MELI_2_FULL;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;


  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [text, setText] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedClienteNombre, setSelectedClienteNombre] = useState("");
  const [selectedClienteTelefono, setSelectedClienteTelefono] = useState("");
  const [alertasEdoCtaCliente, setAlertasEdoCtaCliente] = useState("No");
  const [fecha, setFecha] = useState(hoy);
  const [cortesia, setCortesia] = useState(0);
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransef] = useState(0);
  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [cargos, setCargos] = useState([]);
  const [total, setTotal] = useState(0);
  const [moneda, setMoneda] = useState("");
  const [inputFields, setInputFields] = useState([]);
  const [inputFieldsNC, setInputFieldsNC] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);
  const [password, setPassword] = useState("");

  useMemo(() => {
    if(user.areas){
    if ((user.areas == AREAS_GENERAL)) {
    axios
      .get(`${URL_CLIENTES}Tiendas`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    } else{
      axios
      .get(`${URL_CLIENTES}Area/${user.areas}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    }
  }

  axios
  .get(URL_BANCOS, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allBancos = response.data;
    setBancos(allBancos);
  })
  .catch((err) => {
    console.log(err);
  });

  if(selectedCliente){
    axios
      .get(`${URL_VENTAS_TIENDAS}ClienteAbono/${selectedCliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargos = response.data;
        let arrayTabla = allCargos
        .sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              fecha: a.fecha,
              total_general: a.total_general,
              saldo: a.saldo,
              nota: a.prefijo + a.consecutivo,
              efectivo: 0,
              tdc: 0,
              transfer: 0,
              cortesia: 0,
              totalAbono: 0,
              areas: a.areas[0]._id,
              clientes: a.clientes[0]._id,
              areasName: a.areas[0].name,
              movimiento: "Nota",
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setCargos(dataFinal);
        setInputFields(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_NOTAS_CARGO}Cliente/${selectedCliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargos = response.data;
        let arrayTabla = allCargos
          .map((a) => {
            return {
              id: a._id,
              fecha: a.fecha,
              total_general: a.importe,
              saldo: a.saldo,
              nota: a.idNotaCargo,
              efectivo: 0,
              tdc: 0,
              transfer: 0,
              cortesia: 0,
              totalAbono: 0,
              areas: a.clientes[0].areas[0]._id,
              clientes: a.clientes[0]._id,
              areasName: a.clientes[0].areas[0].name,
              movimiento: "Nota de Cargo",
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setInputFieldsNC(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
    }

  }, [selectedCliente, user]);

  const handleChangeInputEfectivo = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.tdc) +
          parseFloat(i.transfer) +
          parseFloat(i.cortesia);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputTDC = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.efectivo) +
          parseFloat(i.transfer) +
          parseFloat(i.cortesia);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputTransfer = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.efectivo) +
          parseFloat(i.tdc) +
          parseFloat(i.cortesia);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCortesia = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.efectivo) +
          parseFloat(i.tdc) +
          parseFloat(i.transfer);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // NC
  const handleChangeInputEfectivoNC = (id, event) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.tdc) +
          parseFloat(i.transfer) +
          parseFloat(i.cortesia);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
    ActualizaTotales();
  };

  const handleChangeInputTDCNC = (id, event) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.efectivo) +
          parseFloat(i.transfer) +
          parseFloat(i.cortesia);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
    ActualizaTotales();
  };

  const handleChangeInputTransferNC = (id, event) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.efectivo) +
          parseFloat(i.tdc) +
          parseFloat(i.cortesia);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
    ActualizaTotales();
  };

  const handleChangeInputCortesiaNC = (id, event) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        let abonoTemp =
          parseFloat(event.target.value) +
          parseFloat(i.efectivo) +
          parseFloat(i.tdc) +
          parseFloat(i.transfer);
        if (abonoTemp <= i.saldo || event.target.value == "") {
          i[event.target.name] = parseFloat(event.target.value);
          i.totalAbono = abonoTemp;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
    ActualizaTotales();
  };
  // Termina NC

  function ActualizaTotales() {
    let TEfe = inputFields.map((c) => parseFloat(c.efectivo));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);
    let TEfeNC = inputFieldsNC.map((c) => parseFloat(c.efectivo));
    let TENC = TEfeNC.reduce((t, total, index) => t + total, 0);
    setEfectivo(TE + TENC);

    let TTDC = inputFields.map((c) => parseFloat(c.tdc));
    let TD = TTDC.reduce((t, total, index) => t + total, 0);
    let TTDCNC = inputFieldsNC.map((c) => parseFloat(c.tdc));
    let TDNC = TTDCNC.reduce((t, total, index) => t + total, 0);
    setTDC(TD + TDNC);

    let TTra = inputFields.map((c) => parseFloat(c.transfer));
    let TT = TTra.reduce((t, total, index) => t + total, 0);
    let TTraNC = inputFieldsNC.map((c) => parseFloat(c.transfer));
    let TTNC = TTraNC.reduce((t, total, index) => t + total, 0);
    setTransef(TTNC);

    let TCor = inputFields.map((c) => parseFloat(c.cortesia));
    let TC = TCor.reduce((t, total, index) => t + total, 0);
    let TCorNC = inputFieldsNC.map((c) => parseFloat(c.cortesia));
    let TCNC = TCorNC.reduce((t, total, index) => t + total, 0);
    setCortesia(TC + TCNC);

    setTotal(TE + TENC + TD + TDNC + TT + TTNC + TC + TCNC);
  }

  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  async function PDFOC(
    total,
    numero,
    consecutivo,
    areasName,
    efectivo,
    tdc,
    transfer,
    cortesia
  ) {
    const doc = new jsPDF("p", "cm", [8, 10]);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 5, 1, 2, 1);
    doc.setFontSize(6);
    doc.text(`Chamap SA de CV / RFC: CAM210616LD9`, 0.3, 1);
    doc.text(`Manuel Doblado ext 34 int 1`, 0.3, 1.3);
    doc.text(`Colonia: Centro CDMX`, 0.3, 1.6);
    doc.text(`Delegacion: Cuauhtemoc, CP: 06020`, 0.3, 1.9);
    doc.text(`Fecha: ${fecha}`, 0.3, 2.2);
    doc.text(`Abono # ${numero} / Almacen: ${areasName}`, 0.3, 2.5);
    doc.text(`Cliente: ${selectedClienteNombre}`, 0.3, 2.8);
    doc.text(`Nota: ${consecutivo}`, 0.3, 3.1);
    doc.setFontSize(10);
    doc.text(`---ABONO---`, 2.5, 3.8);
    doc.autoTable({
      head: [["Efectivo", "TDC", "Transfer", "Cortesia", "Total"]],
      body: [
        [
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(efectivo),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(tdc),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(transfer),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(cortesia),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total),
        ],
      ],
      styles: {
        fontSize: 8,
      },
      startY: 4,
      theme: "plain",
      margin: { left: 0.3, right: 0.7 },
    });
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");

    if(alertasEdoCtaCliente == "Si"){

      await axios
      .get(`${URL_ESTADO_CUENTA}Tienda/${selectedCliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let movimientos = response.data;
  
      let saldoParcial = 0;
      let totalCargos = 0;
      let totalAbonos = 0;
  
      const data = movimientos.map((a) => {
          totalCargos = totalCargos + a.cargo;
          totalAbonos = totalAbonos + a.abono;
          saldoParcial = saldoParcial + a.cargo - a.abono;
          return [
            a.fecha,
            a.movimiento,
            a.numero,
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
          ];
      });
      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });
      const docW = new jsPDF({compressPdf: true});
      var img = new Image();
      img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
      docW.addImage(img, "png", 150, 5, 33, 10);
      var img2 = new Image();
      img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      docW.addImage(img2, "png", 150, 25, 35, 15);
      // docW.setFontSize(14)
      docW.text(`Estado de Cuenta`, 15, 30);
      docW.text(`Cliente ${selectedClienteNombre}`, 15, 37);
      docW.autoTable({
        head: [
          [
            "Fecha",
            "Movimiento",
            "Numero",
            "Cargos",
            "Abonos",
            "Saldo",
          ],
        ],
        body: dataPDFLimpia,
        startY: 45,
        footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
          [
            "",
            "",
            "",
            {
              content: "Cargos del Periodo",
              colSpan: 2,
              styles: { halign: "left" },
            },
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
          ],
          [
            "",
            "",
            "",
            {
              content: "Abonos del Periodo",
              colSpan: 2,
              styles: { halign: "left" },
            },
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
          ],
          [
            "",
            "",
            "",
            { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
          ],
        ],
        showFoot: "lastPage",
      });
      var attW = docW.output("arraybuffer");
      var base64File = encode(attW);
  
      // axios
      // .post(
      //   `${URL_WHATSAPP}SendPDF`,
      //   {
      //     number: selectedClienteTelefono,
      //     message:`Hola ${selectedClienteNombre}, Aquí te enviamos tu estado de cuenta actualizado`,
      //     base64File,
      //     fileName:`EstadoCuenta.pdf`
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer: ${localStorage.getItem(
      //         "app_token"
      //       )}`,
      //     },
      //   }
      // )
  
    })
    .catch((err) => {
      console.log(err);
    });
      }
  }

  function savePago() {
    setValidaBoton(false);
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el pago",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();
        let totalMails = inputFields.length + inputFieldsNC.length;
        inputFields.map((a) => {
          if (a.efectivo > 0 || a.tdc > 0 || a.transfer > 0 || a.cortesia > 0) {
            axios
              .post(
                URL_ABONOS_TIENDAS,
                {
                  fecha,
                  total: a.totalAbono,
                  areas: a.areas,
                  clientes: a.clientes,
                  ventasTiendas: a.id,
                  bancos: selectedBanco,
                  efectivo: a.efectivo,
                  tdc: a.tdc,
                  transfer: a.transfer,
                  cortesia: a.cortesia,
                  nomina:0
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
                PDFOC(
                  a.totalAbono,
                  data.data.idAbonoTiendas,
                  a.nota,
                  a.areasName,
                  a.efectivo,
                  a.tdc,
                  a.transfer,
                  a.cortesia
                );
                axios.patch(
                  `${URL_VENTAS_TIENDAS}/${a.id}`,
                  {
                    saldo: a.saldo - a.totalAbono,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );

                axios
                .post(
                  `${URL_MOVIMIENTOS_BANCOS}`,
                  {
                    fecha,
                    importe: a.totalAbono,
                    tipo:"Ingreso",
                    bancos: selectedBanco,
                    abonosTiendas:data.data._id,
                    moneda,
                    tipoCambio:1
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )

                totalMails = totalMails - 1;
                if (totalMails == 0) {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            totalMails = totalMails - 1;
            if (totalMails == 0) {
              Swal.fire("Good job!", "Creado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          }
        });

        // NC
        inputFieldsNC.map((a) => {
          if (a.efectivo > 0 || a.tdc > 0 || a.transfer > 0 || a.cortesia > 0) {
            axios
              .post(
                URL_ABONOS_TIENDAS,
                {
                  fecha,
                  total: a.totalAbono,
                  areas: a.areas,
                  clientes: a.clientes,
                  bancos: selectedBanco,
                  notasCargo: a.id,
                  efectivo: a.efectivo,
                  tdc: a.tdc,
                  transfer: a.transfer,
                  cortesia: a.cortesia,
                  nomina:0
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
                PDFOC(
                  a.totalAbono,
                  data.data.idAbonoTiendas,
                  a.nota,
                  a.areasName,
                  a.efectivo,
                  a.tdc,
                  a.transfer,
                  a.cortesia
                );
                axios.patch(
                  `${URL_NOTAS_CARGO}AplicarAbono/${a.id}`,
                  {
                    saldo: a.saldo - a.totalAbono,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                axios
                .post(
                  `${URL_MOVIMIENTOS_BANCOS}`,
                  {
                    fecha,
                    importe: a.totalAbono,
                    tipo:"Ingreso",
                    bancos: selectedBanco,
                    abonosTiendas:data.data._id,
                    moneda,
                    tipoCambio:1
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                totalMails = totalMails - 1;
                if (totalMails == 0) {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            totalMails = totalMails - 1;
            if (totalMails == 0) {
              Swal.fire("Good job!", "Creado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          }
        });
      }
    });
  }



  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });


  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.abonosTiendas ? (
        <div className="card container col-sm-11">
          <h3 align="center">Captura un Pago</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Cliente</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      if (selectedCliente) {
                        setValue(selectedCliente);
                        setSelectedCliente(selectedCliente._id);
                        setSelectedClienteNombre(selectedCliente.nombre_comercial);
                        setSelectedClienteTelefono(selectedCliente.telefono);
                        setAlertasEdoCtaCliente(selectedCliente.alertasEdoCta);
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      jalaBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={1}>
                  <Label>Cortesia</Label>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={(e) => toggleCambiaPrecio()}
                  >
                    Aut. Cortesia
                  </Button>
                </Col>

                <Col md={5}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)}
                    </Badge>
                  </h4>
                </Col>
              </Row>
              <br />
              <Row>
                {/* Tabla Cargos */}
                <br />
                <br />
                <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Movimiento</th>
                      <th>Nota</th>
                      <th>Importe</th>
                      <th>Abonos</th>
                      <th>Saldo</th>
                      <th>Efectivo</th>
                      <th>TDC</th>
                      <th>Transfer</th>
                      <th>Cortesia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields.map((a) => (
                      // <div key={a.id}>
                      <tr>
                        <td>{a.fecha}</td>
                        <td>{a.movimiento}</td>
                        <td>{a.nota}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              a.total_general
                            )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              a.total_general - a.saldo
                            )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo)}
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="number"
                            min="0"
                            step="any"
                            name="efectivo"
                            value={a.efectivo}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputEfectivo(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="number"
                            min="0"
                            step="any"
                            name="tdc"
                            value={a.tdc}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputTDC(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="number"
                            min="0"
                            step="any"
                            name="transfer"
                            value={a.transfer}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputTransfer(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          {user.cambiaPrecios ? (
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="any"
                              name="cortesia"
                              value={a.cortesia}
                              key={a.id}
                              onChange={(e) => {
                                handleChangeInputCortesia(a.id, e);
                              }}
                            />
                          ) : cambiarPrecio ? (
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="any"
                              name="cortesia"
                              value={a.cortesia}
                              key={a.id}
                              onChange={(e) => {
                                handleChangeInputCortesia(a.id, e);
                              }}
                            />
                          ) : (
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="any"
                              name="cortesia"
                              value={a.cortesia}
                              key={a.id}
                              disabled
                            />
                          )}
                        </td>
                      </tr>
                      // </div>
                    ))}

                    {/* NC */}

                    {inputFieldsNC.map((a) => (
                      // <div key={a.id}>
                      <tr>
                        <td>{a.fecha}</td>
                        <td>{a.movimiento}</td>
                        <td>{a.nota}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              a.total_general
                            )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              a.total_general - a.saldo
                            )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo)}
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="number"
                            min="0"
                            step="any"
                            name="efectivo"
                            value={a.efectivo}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputEfectivoNC(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="number"
                            min="0"
                            step="any"
                            name="tdc"
                            value={a.tdc}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputTDCNC(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="number"
                            min="0"
                            step="any"
                            name="transfer"
                            value={a.transfer}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputTransferNC(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          {user.cambiaPrecios ? (
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="any"
                              name="cortesia"
                              value={a.cortesia}
                              key={a.id}
                              onChange={(e) => {
                                handleChangeInputCortesiaNC(a.id, e);
                              }}
                            />
                          ) : cambiarPrecio ? (
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="any"
                              name="cortesia"
                              value={a.cortesia}
                              key={a.id}
                              onChange={(e) => {
                                handleChangeInputCortesiaNC(a.id, e);
                              }}
                            />
                          ) : (
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="any"
                              name="cortesia"
                              value={a.cortesia}
                              key={a.id}
                              disabled
                            />
                          )}
                        </td>
                      </tr>
                      // </div>
                    ))}

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        Total
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(efectivo)}
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(tdc)}
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(transfer)}
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(cortesia)}
                      </td>
                    </tr>
                  </tbody>
                  <br />
                </Table>

                {/* Termina tabla cargos */}
              </Row>
            </FormGroup>
            <br />
            <Row>
              <Button className="btn btn-success" onClick={savePago}>
                {" "}
                Registrar
              </Button>

              <Button
                href="/ListadoAbonosTiendas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Cortesia</h4>
            </ModalHeader>
            <ModalBody>
              <Input
                bsSize="sm"
                type="password"
                placeholder="Password"
                value={password}
                required
                onChange={(event) => setPassword(event.target.value)}
              />
              <br />
              <Row>
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => autorizaCambio()}
                  >
                    Autorizar
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      
    </>
  );
}

export default AbonosTiendasCreate;
